import React from 'react';
import { Navigate } from 'react-router-dom';

// MAIN
import Agents from '../pages/main/Agents';
import Admins from '../pages/main/Admins';
import Users from '../pages/main/Users';
import Terminals from '../pages/main/Terminals';
import Transactions from '../pages/main/Transactions';
import Sellers from '../pages/main/Sellers';
import SellerViewPage from '../pages/main/SellerViewPage';
import Regions from '../pages/main/Regions';
import Bazaars from '../pages/main/Bazaars';
import SellerTransactions from '../pages/main/SellerTransactions';
import CardTransactions from '../pages/main/CardTransactions';
import Categories from '../pages/main/Categories';
import Products from '../pages/main/Products';
import ProductDetail from '../pages/main/ProductDetail';
import ProductAdd from '../pages/main/ProductAdd';
import DashboardEcommerce from '../pages/DashboardEcommerce';

//AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
//pages
import Settings from '../pages/Pages/Profile/Settings/Settings';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import BasicPasswCreate from '../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate';

//login
import Login from '../pages/Authentication/Login';
import ForgetPasswordPage from '../pages/Authentication/ForgetPassword';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';

// User Profile
import UserProfile from '../pages/Authentication/user-profile';

const authProtectedRoutes = [
  { path: '/agents', component: <Agents /> },
  { path: '/admins', component: <Admins /> },
  { path: '/users', component: <Users /> },
  { path: '/terminals', component: <Terminals /> },
  { path: '/settings', component: <Settings /> },
  { path: '/transactions', component: <Transactions /> },
  { path: '/sellers', component: <Sellers /> },
  { path: '/sellers/:sellerId', component: <SellerViewPage /> },
  { path: '/seller-transactions', component: <SellerTransactions /> },
  { path: '/card-transactions', component: <CardTransactions /> },
  { path: '/regions', component: <Regions /> },
  { path: '/bazaars', component: <Bazaars /> },
  { path: '/categories', component: <Categories /> },
  { path: '/products', component: <Products /> },
  { path: '/products/create', component: <ProductAdd /> },
  { path: '/products/edit/:id', component: <ProductAdd /> },
  { path: '/products/:id', component: <ProductDetail /> },
  { path: '/dashboard', component: <DashboardEcommerce /> },

  { path: '/profile', component: <UserProfile /> },
  {
    path: '/',
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: '*', component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: '/logout', component: <Logout /> },
  { path: '/login', component: <Login /> },
  { path: '/forgot-password', component: <ForgetPasswordPage /> },
  { path: '/register', component: <Register /> },
  { path: '/auth-signin-basic', component: <BasicSignIn /> },
  { path: '/auth-signup-basic', component: <BasicSignUp /> },
  { path: '/auth-pass-reset-basic', component: <BasicPasswReset /> },
  { path: '/auth-success-msg-basic', component: <BasicSuccessMsg /> },
  { path: '/auth-twostep-basic', component: <BasicTwosVerify /> },
  { path: '/auth-404-basic', component: <Basic404 /> },
  { path: '/pages-maintenance', component: <Maintenance /> },
  { path: '/auth-pass-change-basic', component: <BasicPasswCreate /> },
];

export { authProtectedRoutes, publicRoutes };
